export default __webpack_public_path__ + "static/media/pexels-pavel-danilyuk-5495790.6a8f6b26.mp4";